let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bLQZ9")).then(() => parcelRequire('6QVDr'));